import React, { useMemo, useState } from "react";
import { ATADI_INFO } from "../../constants/common";
import ChangeLanguage from "./ChangeLanguage";
import {
  IconLogoAtadi,
  IconHeadPhone,
  IconMenuFold,
  IconAgency,
  IconMailOutline,
  IconContact,
  IconAboutAtadi,
  IconLogout,
  IconSupport,
  IconZalo,
  IconFbMessenger,
} from "../icons";
import { useAuth } from "../../contexts/authContext";
import { Button, Dropdown, MenuProps, Modal, Space } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import UserInfo from "./UserInfo";
import { commonUtil } from "../../utils";
import {
  LIST_LINK_PROFILE,
  LIST_ROUTER_MENU_MOBILE,
} from "../../constants/check";

const MenuMobile = (props: { isOpen: boolean; closeMenu: Function }) => {
  const { t } = useTranslation(["common", "notification"]);
  const auth = useAuth();
  const history = useHistory();

  const onClickLogin = () => {
    history.push(`/login${window.location.search}`);
    props.closeMenu();
  };

  const onClickRegister = () => {
    history.push(`/register${window.location.search}`);
    props.closeMenu();
  };

  const getDisplayName = () => {
    if (!auth || !auth.user) {
      return "";
    }
    if (auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name + " " + auth.user.first_name;
    }
    if (auth.user.first_name && !auth.user.last_name) {
      return auth.user.first_name;
    }
    if (!auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name;
    }
    return auth.user.phone || auth.user.email || "User";
  };

  const onClickLogout = () => {
    commonUtil.deleteSession();
    auth.logout();
    history.push("/login");
    props.closeMenu();
  };

  const onClickAccountInfo = () => {
    history.push("/profile");
    props.closeMenu();
  };

  const filteredLinks = useMemo(() => {
    const result = LIST_LINK_PROFILE.filter((item: any) => {
      return (
        !item?.role?.length || item?.role?.includes(auth.user?.business_role)
      );
    });
    return result;
  }, [auth.user?.business_role]);

  const handleClickLink =
    ({ link, isOpenNewTab }: any) =>
    () => {
      if (isOpenNewTab) {
        if (typeof window !== "undefined") {
          window.open(`${link}`);
        }
      } else {
        // history.push({
        //   pathname: link,
        // })
        window.open(link);
      }
      props.closeMenu();
    };

  return (
    <div className={props.isOpen ? "menu-mobile open" : "menu-mobile"}>
      <div className="menu-mobile-cont">
        <div className="menu-mobile-header">
          <div
            style={{
              width: "60px",
              height: "60px",
              borderRadius: "50%",
              overflow: "hidden",
            }}
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src="https://statics.vntrip.vn/images/default-avatar.png"
              alt="avatar"
            />
          </div>
          {!auth.isAuthenticated ? (
            <div style={{ width: "calc(100% - 50px)", textAlign: "center" }}>
              <Button
                style={{
                  margin: "5px",
                  color: "#ef4343",
                  borderColor: "#ef4343",
                  backgroundColor: "white",
                }}
                onClick={onClickLogin}
              >
                {t("common:Đăng nhập")}
              </Button>
              <Button type="primary" onClick={onClickRegister}>
                {t("common:Đăng ký")}
              </Button>
            </div>
          ) : (
            <div style={{ paddingLeft: "16px" }}>
              <p className="font-medium mb-8">
                ID Thành viên: {auth?.user?.user_id}
              </p>
              <p className="font-medium">{getDisplayName()}</p>
            </div>
          )}
        </div>

        <div className="w-full h-6 bg-[#eee]"></div>

        <div className="menu-mobile-body flex flex-col items-start">
          <ul className="menuMobile__list container">
            <li>
              <button onClick={() => {}}>
                <IconAgency />
                <span className="uppercase font-semibold text-linear-blue">
                  {t(`Đăng ký đại lý`)}
                </span>
              </button>
            </li>

            {LIST_ROUTER_MENU_MOBILE.map(
              ({ key, label, link, translate, isOpenNewTab, icon: Icon }) => {
                return (
                  <li key={key}>
                    <button
                      onClick={handleClickLink({
                        key,
                        label,
                        link,
                        isOpenNewTab,
                      })}
                    >
                      <Icon />
                      <span className="">{t(`${translate}:${label}`)}</span>
                    </button>
                  </li>
                );
              }
            )}
          </ul>

          <div className="w-full h-6 bg-[#eee]"></div>

          {auth.isAuthenticated ? (
            <>
              <ul className="menuMobile__list container">
                {filteredLinks.map(
                  ({ link, openNewTab, icon, label, border }) => {
                    return (
                      <li key={link}>
                        <a
                          href={link}
                          target={openNewTab ? "_blank" : ""}
                          // onMouseEnter={closeSideBar}
                        >
                          {icon}
                          <span className="md:text-md">{t(label)}</span>
                        </a>
                        {border ? (
                          <div className="hidden lg:block my-8 bg-grey-2 w-full h-0.5"></div>
                        ) : null}
                      </li>
                    );
                  }
                )}
              </ul>
              <div className="w-full h-6 bg-[#eee]"></div>
            </>
          ) : null}

          <ul className="menuMobile__list container">
            <li className="py-16">
              <ChangeLanguage />
            </li>
          </ul>

          <div className="w-full h-6 bg-[#eee]"></div>

          <ul className="menuMobile__list container">
            <li>
              <a href={`${process.env.REACT_APP_URL_ATADI}/ve-vntrip`}>
                <IconAboutAtadi />
                <span>{t("common:Về Atadi")}</span>
              </a>
            </li>

            <li>
              <a href={`mailto:${ATADI_INFO.email}`}>
                <IconMailOutline />
                <span>{ATADI_INFO.email}</span>
              </a>
            </li>

            <li>
              <a href={`${process.env.REACT_APP_URL_ATADI}/lien-he`}>
                <IconContact />
                <span>{t("common:Liên hệ")}</span>
              </a>
            </li>
          </ul>
          {auth.isAuthenticated ? (
            <div
              style={{
                width: "100%",
                padding: "10px 12px",
                borderTop: "1px solid #eee",
              }}
            >
              {/* <Button
                size="large"
                type="primary"
                block={true}
                onClick={onClickLogout}
              >
                {t("common:Đăng xuất")}
              </Button> */}
              <Button
                className="w-fit border-none pl-0 bg-white gap-16 shadow-none"
                onClick={onClickLogout}
              >
                <div className="">
                  <IconLogout width={16} height={16} fill={"#EF4343"} />
                </div>
                <span className="text-red-primary text-md font-semibold">
                  {t("common:Đăng xuất")}
                </span>
              </Button>
            </div>
          ) : null}
        </div>
      </div>
      <div
        className="menu-mobile-backdrop"
        onClick={() => {
          props.closeMenu();
        }}
        onKeyUp={() => {
          props.closeMenu();
        }}
        role={"button"}
        tabIndex={0}
      ></div>
    </div>
  );
};

const HeaderMobile = (props: { openMenu: Function }) => {
  const history = useHistory();
  const [openModal, setOpenModal] = useState<boolean>(false);

  return (
    <div className="header h-[60px] md:h-auto md:hidden">
      <div
        className="container mx-auto"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: "100%",
        }}
      >
        <a
          onClick={() => {
            props.openMenu();
          }}
        >
          <IconMenuFold />
        </a>
        <a
          className="logo w-[100px] cursor-pointer"
          href={`${process.env.REACT_APP_URL_ATADI}`}
        >
          <img src={ATADI_INFO.logo} alt="logo" />
        </a>
        <div onClick={() => setOpenModal(true)}>
          <IconSupport />
        </div>
      </div>
      <Modal
        visible={openModal}
        centered
        footer={null}
        onCancel={() => setOpenModal(false)}
        width={400}
      >
        <p className="font-semibold text-xl text-center">Hỗ trợ</p>

        <div className="mt-24">
          <div className="py-8">
            <a
              className="hover:text-black-2 flex gap-4 items-center justify-between"
              href={`tel:${ATADI_INFO.hotline.trim()}`}
            >
              <div className="flex items-center gap-4">
                <IconHeadPhone color="#595959" /> <span>Hotline</span>
              </div>
              <span className="text-blue-link">{ATADI_INFO.hotline}</span>
            </a>
          </div>
          <div className="py-8">
            <a
              href={ATADI_INFO.zalo_link}
              target="_blank"
              className="hover:text-black-2 flex gap-4 items-center justify-between"
            >
              <div className=" flex items-center gap-4">
                <IconZalo color="#595959" /> <span>Zalo</span>
              </div>
              <p
                className="text-blue-link"
                style={{
                  display: "inline-block",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  maxWidth: 130,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Nhắn tin ngay
              </p>
            </a>
          </div>
          <div className="py-8">
            <a
              href={ATADI_INFO.facebook_messenger_link}
              target="_blank"
              className="hover:text-black-2 flex gap-4 items-center justify-between"
            >
              <div className="flex items-center gap-4">
                <IconFbMessenger color="#595959" /> <span>Messenger</span>
              </div>
              <p
                className="text-blue-link"
                style={{
                  display: "inline-block",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 1,
                  maxWidth: 130,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                Nhắn tin ngay
              </p>
            </a>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const items: MenuProps["items"] = [
  {
    key: "1",
    label: (
      <div className="py-8">
        <a
          href={`tel:${ATADI_INFO.hotline.trim()}`}
          rel="noopener noreferrer"
          className="hover:text-black-1"
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <IconHeadPhone color="#595959" />
              Hotline
            </div>
            <span className="text-blue-link ">{ATADI_INFO.hotline}</span>
          </div>
        </a>
      </div>
    ),
  },
  {
    key: "2",
    label: (
      <div className="py-8">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ATADI_INFO.zalo_link}
          className="hover:text-black-1"
        >
          <div className="flex items-center justify-between ">
            <div className="flex items-center gap-4">
              <IconZalo color="#595959" />
              Zalo
            </div>
            <span className="text-blue-link">Nhắn tin ngay</span>
          </div>
        </a>
      </div>
    ),
  },
  {
    key: "3",
    label: (
      <div className="py-8">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={ATADI_INFO.facebook_messenger_link}
          className="hover:text-black-1"
        >
          <div className="flex items-center justify-between ">
            <div className="flex items-center gap-4">
              <IconFbMessenger color="#595959" />
              Messenger
            </div>
            <span className="text-blue-link">Nhắn tin ngay</span>
          </div>
        </a>
      </div>
    ),
  },
];

const HeaderDesktop = () => {
  const { t } = useTranslation(["common", "notification"]);
  const auth = useAuth();
  const history = useHistory();

  const onClickLogin = () => {
    history.push(`/login${window.location.search}`);
  };

  const onClickRegister = () => {
    history.push(`/register${window.location.search}`);
  };

  return (
    <div className="header header-desktop hidden md:flex">
      <div
        className="container mx-auto"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <a
          className="logo w-[120px] cursor-pointer"
          href={`${process.env.REACT_APP_URL_ATADI}`}
        >
          <img
            src={ATADI_INFO.logo}
            alt="logo"
            // className="absolute inset-0"
          />
        </a>
        <ul
          style={{
            display: "flex",
            alignItems: "center",
            listStyle: "none",
            padding: 0,
            margin: 0,
          }}
        >
          <li style={{ margin: "0 10px" }}>
            <Dropdown
              menu={{ items }}
              overlayStyle={{
                width: 280,
                borderRadius: "4px",
                boxShadow: " 0 2px 8px rgba(0, 0, 0, .15)",
                cursor: "pointer",
              }}
            >
              <a
                onClick={(e) => e.preventDefault()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#EF4343",
                  gap: 8,
                  fontSize: 16,
                }}
              >
                <IconSupport />
                {t("common:Hỗ trợ")}
              </a>
            </Dropdown>
          </li>
          <li style={{ margin: "0 10px" }}>
            <ChangeLanguage />
          </li>
          {!auth.isAuthenticated ? (
            <>
              <li style={{ margin: "0 10px" }}>
                <Button
                  style={{
                    color: "#EF4343",
                    borderColor: "#EF4343",
                    backgroundColor: "white",
                  }}
                  onClick={onClickLogin}
                >
                  {t("common:Đăng nhập")}
                </Button>
              </li>
              <li>
                <Button type="primary" onClick={onClickRegister}>
                  {t("common:Đăng ký")}
                </Button>
              </li>
            </>
          ) : null}
          {auth.isAuthenticated ? (
            <li>
              <UserInfo />
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

const HeaderTop = () => {
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  return (
    <>
      <HeaderMobile
        openMenu={() => {
          setIsOpenMenu(true);
        }}
      />
      <MenuMobile
        isOpen={isOpenMenu}
        closeMenu={() => {
          setIsOpenMenu(false);
        }}
      />
      <HeaderDesktop />
    </>
  );
};

export default HeaderTop;
